require('./accountDebitsView.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ Actions
import { changeTab } from 'actions/accountDebits';

// @core
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const { AccountDebits } = require('components/accounts/accountDebits/accountDebits');
import OKLayout from 'components/commons/OKLayout/OKLayout';
const AccountMoreOptionsButton = require('components/accounts/accountMoreOptionsButton/accountMoreOptionsButton');

// @commons
const { OKIconTask } = require('commonsComponents/OKIconTask');
const { PopoverMenu } = require('commonsComponents/popoverMenu');

// @utilities
const AccessHelper = require('utilities/accessHelper');
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
const { toCamelCase, getLastNChars } = require('utilities/stringHelper');

// @ constants
const { BRING_DIRECT_DEBITS } = require('constants/flagBasedFeatures');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

class AccountDebitsView extends React.PureComponent {
    componentDidMount() {
        const { history, immAccounts, match: { params: { accountId } } } = this.props;
        AccessHelper.allowAccess(accountConstants.ACCOUNTS_DEBITS, { immAccounts, accountId }, history);
    }

    handleChangeTab = (tab) => {
        this.props.changeTab(tab)
    }

    renderBreadCrums = (alias, accountId) => {
        return [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: alias,
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('breadcrumb-debits'),
                url: ''
            }
        ];
    }

    renderButtons = (isInactiveAccount) => {
        if (this.props.uploadImgDomiciliacionEnabled) {
            const { match: { params: { accountId } }, flagBasedFeatures } = this.props;
            const linkDirectDebit = `/myprofile/accounts/${accountId}/direct-debit`;

            let directDebitButton;
            if (flagBasedFeatures.get(BRING_DIRECT_DEBITS)) {
                directDebitButton = (
                    <OKButton
                        modifier="ghost"
                        inverse={true}
                        to={linkDirectDebit}
                        disabled={isInactiveAccount}
                    >
                        <FormattedText value="accountDebits-directDebitButton" />
                    </OKButton>
                )
            }

            const moreOptions = __CONTACT_CENTER__ && <AccountMoreOptionsButton accountId={accountId} />
            const popOver = (
                <PopoverMenu
                    target={<OKIconTask activeHover={false} icon="icon-s-op-comp" type="standalone" style="dark-bg" />}
                    items={[{
                        link: linkDirectDebit,
                        text: formatText('accountDebits-directDebitButton')
                    }]}
                    placement="bottomRight"
                />
            )

            if (__CONTACT_CENTER__) {
                return (
                    <React.Fragment>
                        {directDebitButton}
                        {moreOptions}
                    </React.Fragment>
                )
            }

            return (
                <div className="account-debits-view__direct-debit-button">
                    <div className="hidden-xs">
                        {directDebitButton}
                    </div>
                    <div className="visible-xs">
                        {popOver}
                    </div>
                </div>
            )
        }
    }

    render() {
        const {
            immAccountDebits,
            immAccounts,
            match: { params: { accountId } },
        } = this.props;
        const immAccount = immAccounts.getIn(['byId', accountId]);
        const alias = immAccount.get('isAliasUpdating') ? toCamelCase(immAccount.get('aliasTentative')) : toCamelCase(immAccount.get('alias'));
        const subtitleLeft = immAccount.getIn(['catalogData', 'subtype']);
        const subtitleRight = getLastNChars(immAccount.get('iban'));
        const activeTab = immAccountDebits.get('activeTab');
        const isInactiveAccount = immAccount.get('isInactiveAccount');
        const tabs = [
            { label: formatText('accountDebits-receiptsView') },
            { label: formatText('accountDebits-authorizationsView') }
        ];
        return (
            <OKLayout
                breadcrumb={this.renderBreadCrums(alias, accountId)}
                className="account-debits-view"
                title={getFinalTitle('landingHeader-debits')}
                loading={!(immAccounts && immAccounts.getIn(['byId', accountId]))}
                overlap={false}
                section="accounts"
                subtitleLeft={subtitleLeft}
                subtitleRight={subtitleRight}
                buttons={this.renderButtons(isInactiveAccount)}
                onTabSelection={this.handleChangeTab}
                activeTab={activeTab}
                tabId="accountDebitsTabs"
                tabs={tabs}
                tabsCustomClassName="account-debits-view__tabs"
                tabbedBoxIsResponsive={true}
            >
                <div className="row">
                    <div className="col-xs-12">
                        <AccountDebits immAccount={immAccount} immAccounts={immAccounts} />
                    </div>
                </div>
            </OKLayout>
        )

    }
}

AccountDebitsView.propTypes = {
    changeTab: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccountDebits: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    uploadImgDomiciliacionEnabled: PropTypes.bool,
    flagBasedFeatures: PropTypes.object
};

module.exports.constructor = AccountDebitsView;
module.exports.AccountDebitsView = connect(
    state => ({
        immAccounts: state.accounts,
        uploadImgDomiciliacionEnabled: state.flagBasedFeatures.get('upload-img-domiciliacion-enabled'),
        immAccountDebits: state.accountDebits,
        flagBasedFeatures: state.flagBasedFeatures,
    }), {
    changeTab,
}
)(withFeatureToggling(withRouter(AccountDebitsView)));
